<div class="container-fluid" style="padding: 0;">
    <div class="ng-Header col-xs-12">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Scrutiny of
      inspection reports and recommendation
    </div>
    <nz-descriptions nzTitle="Basic Information" style="padding: 10px;">
      <nz-descriptions-item nzTitle="STP Name"> {{ scrutinyReportInfo?.stpName }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="STP ID">{{ scrutinyReportInfo?.stpRegistrationNo }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Application ID">{{ scrutinyReportInfo?.applicationId }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Date of Application">{{ scrutinyReportInfo?.applicationDate }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Date of Inspection conducted">{{ scrutinyReportInfo?.inspectionConductedDate}}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="GPS Location">NA</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Inspection Conducted By-1">{{ this.designation }}
        <!-- <ng-container *ngIf="!this.designation">{{ nsdaOfficerName }}</ng-container> -->
      </nz-descriptions-item>
      <nz-descriptions-item nzTitle="Inspection Conducted By-2">{{ scrutinyReportInfo?.inspectorOfficer1 }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Inspection Conducted By-3">{{ scrutinyReportInfo?.inspectorOfficer2 }}</nz-descriptions-item>
      <nz-descriptions-item nzTitle="Inspection Conducted By-4">{{ scrutinyReportInfo?.inspectorOfficer3 }}</nz-descriptions-item>
    </nz-descriptions>


    <div class="ng-Header col-xs-12 mt-2">
      <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Details Inspection Report
    </div>
    <div nz-col [nzSpan]="24">
      <nz-table #basicTable [nzData]="detailsInspectionReportList" nzTableLayout="fixed" nzShowSizeChanger nzBordered
        nzSize="middle" nzAlign="middle" [nzFrontPagination]="false" [nzTotal]="total" [(nzPageSize)]="size"
        [nzShowTotal]="totalRowRangeTemplate" [(nzPageIndex)]="page" (nzQueryParams)="onQueryParamsChange($event)">
        <ng-template #totalRowRangeTemplate let-range="range" let-total style="text-align: left">
          <div style="text-align: left">
            Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
          </div>
        </ng-template>
        <thead>
          <tr style="overflow: auto">
            <th style="width: 100px; text-align: center" rowspan="1">Sl.</th>
            <th style="text-align: center" rowspan="2">Application for</th>
            <th style="text-align: center" rowspan="2">Application Type</th>
            <th style="text-align: center" rowspan="2">Inspection Result for STP/SAC Registration</th>
            <th style="text-align: center" rowspan="2">Scrutiny Result for STP/SAC Registration</th>
            <th style="text-align: center" rowspan="2">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of basicTable.data; let i = index">
            <td style="text-align: center">{{ (page - 1) * size + 1 + i }}</td>
            <td style="text-align: center">{{ data?.occupationName ? data?.occupationName : 'NA'  }}</td>
            <td style="text-align: center">{{ data?.applicationType ? data?.applicationType : 'NA' }}</td>
            <td style="text-align: center">{{ data?.regInsStpSac ? data?.regInsStpSac : 'NA' }}</td>
            <td style="text-align: center">{{data?.scrutinyRegInsStpSac ? data?.scrutinyRegInsStpSac : 'NA'}}</td>
            <td style="text-align: center; vertical-align: middle">
              <button type="button" (click)="onEditStpSac(inspectionId)" nz-button nzType="default" [nzSize]="'small'">
                <i nz-icon nzType="edit" nzTheme="fill"></i>
              </button>
              |
              <button type="button" (click)="onViewStpSac(inspectionId)" nz-button nzType="default" [nzSize]="'small'">
                <i nz-icon nzType="eye" nzTheme="fill"></i>
              </button>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </div>

    <div class="col-md-12 col-sm-12">
      <nz-form-item>
        <nz-form-control>
          <nz-form-label>Rollback Remarks</nz-form-label>
          <textarea nz-input placeholder="Remarks" [formControl]="upDatedRemarks"></textarea>
        </nz-form-control>
      </nz-form-item>
    </div>

    <div class="row justify-content-end">
      <button class="col-md-2 col-sm-12 mt-2"(click)="onScrutinyResultRollBack()" [disabled]="rollbackBtnDisable"  nz-button nzType="primary" style="margin-top: 15px;">Rollback</button>
      <button class="col-md-2 col-sm-12 mt-2" (click)="onScrutinyResultSubmit()" [disabled]="scrutinyBtnDisable" nz-button nzType="primary" style="margin-top: 15px;margin-left: 20px;">Submit Scrutiny Result</button>
    </div>
</div>
